define((require) => {
    "use strict";

    const _ = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    /**
     * Base model for widgets owned by a company.
     *
     * @class AbstractWonedWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("AbstractOwnedWidgetModel", {

        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            hideOnBackgroundScene: true,
            icon: null,
            visible: true,
            widgetId: null
        })
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/AbstractOwnedWidgetModel.js